export default __webpack_public_path__ + "static/media/lacteos.d6e2016d.jpg";